"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delegation = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsMySpecialProduct_1 = require("../../model/hsMySpecialProduct");
var service_1 = require("../../../library/base/service");
var Delegation = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Delegation, _super);
    function Delegation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '特约产品购买接口';
        _this.code = '105034';
        _this.desc = '特约产品购买接口';
        _this.requestParams = new hsMySpecialProduct_1.DelegationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Delegation;
}(service_1.BaseService));
exports.Delegation = Delegation;
//# sourceMappingURL=delegation.js.map